import React, { useState, useEffect, useCallback } from "react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import debounce from "lodash/debounce";

interface SearchBarProps {
  onSearch: (term: string) => void;
  placeholder?: string;
  paramName?: string;
  className?: string;
  value?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({ onSearch, placeholder = "Suchen...", paramName = "search", className = "", value = "" }) => {
  const [searchTerm, setSearchTerm] = useState(value);

  // Create a debounced version of the search function
  const debouncedSearch = useCallback(
    debounce((term: string) => {
      onSearch(term);
    }, 300),
    [onSearch]
  );

  useEffect(() => {
    setSearchTerm(value);
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setSearchTerm(newValue);
    debouncedSearch(newValue);
  };

  return (
    <div className={`relative ${className}`}>
      <input type="text" value={searchTerm} onChange={handleChange} placeholder={placeholder} className="input input-bordered w-full h-10 pl-10 text-sm" />
      <MagnifyingGlassIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
    </div>
  );
};

export default SearchBar;
